import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import {
  Skeleton,
  Typography,
  Affix,
  Tabs,
  Spin,
  Collapse,
  Button,
  Tag
} from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { contractsStatuses } from '../../utils/constants/tagColors';
import useAuthContext from '../../contexts/AuthContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import ContentCustom from '../../components/ContentCustom/ContentCustom';
import useListContent from './listContent';
import DescriptionList from '../../components/DescriptionList/DescriptionList';
import useErrorMessage from '../../utils/ErrorMessage';
import UpdateBankInfo from './UpdateBankInfo';
import UpdateContractStatusInfo from './UpdateContractStatusInfo';
import QuittanceTable from './QuittanceTable';
import PaperWorkFeeTable from './PaperWorkFeeTable';
import Actions from './Actions';
import Historic from './Historic';
import GoogleMap from '../../components/Map/GoogleMap';
import Messages from '../tickets/Messages';
import InfosBar from '../quotes/InfosBar';
import MessageHistory from './MessageHistory';
import MissingDocuments from './MissingDocuments';
import { UpdateDetailsDrawer } from './UpdateDetailsDrawer';
import useContractsContext from './ContractsContext';
import MyDocuments from './MyDocuments';
import PaperworkFeePaymentModal from './PaperworkFeePaymentModal';
import PaymentAlertModal from './PaymentAlertModal';
import { customerRoutes } from '../../utils/constants/routes';
import ExemptionModal from './ExemptionModal';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const ShowContract = () => {
  const [activeTitle, setActiveTitle] = useState();
  const { forceRefresh, setUpdateStatusVisible } = useContractsContext();
  const { message } = useErrorMessage();
  const { t } = useTranslation();
  const { dispatchAPI, user } = useAuthContext();
  const isCustomer = user?.role === 'guests:GUEST';
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentAlert, setPaymentAlert] = useState(false);
  const [switchTerminationContract, setSwitchTerminationContract] =
    useState(false);
  const { id } = useParams();
  const [schema, setSchema] = useState();
  const [contract, setContract] = useState({
    status: 'QUOTE'
  });
  const [openLastStepModal, setOpenLastStepModal] = useState(false);
  const [openExemptionModal, setOpenExemptionModal] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [tempData, setTempData] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get('av') || 'root';
  const action = params.get('action');
  const amendmentIndex = params.get('av');
  const paperworkFeeNotPaid =
    contract?.paperwork_fee_invoice &&
    contract.paperwork_fee_invoice[0]?.paperworkFee_status === 'NOT_PAID' &&
    contract.paperwork_fee_invoice[0]?.paperwork_fee_payment_choices === 'CB';
  const paperworkFeeDrawn =
    contract?.paperwork_fee_invoice &&
    contract.paperwork_fee_invoice[0]?.paperworkFee_status === 'NOT_PAID' &&
    contract.paperwork_fee_invoice[0]?.paperwork_fee_payment_choices ===
      'ASSURMAX';
  const shownContract =
    activeTab === 'root' || !contract?.amendment
      ? contract
      : contract?.amendment[activeTab];
  const {
    costInfo,
    contractInfo,
    optionInfo,
    firstStepInfo,
    antecedentsInfo,
    contributionInfo,
    bankInfo,
    contractStatusInfo,
    list
  } = useListContent(shownContract, contract && contract?.type?.toLowerCase());

  const statusMissingParts = [
    'QUOTE',
    'TERMINATED',
    'TERMINATED_NON_PAYMENT',
    'WITHOUT_EFFECT',
    'DELETE',
    'OBSOLETE'
  ];

  let pageHeaderTitle = t(
    `${contract?.status === 'QUOTE' ? 'quotes' : 'contracts'}.show.title`
  );
  if (contract?.exemption)
    pageHeaderTitle = contract?.previous_contract
      ? t('tickets.show.amendment')
      : t('tickets.show.title');

  /*
   * TODO: ADD TO I18N
   */
  const title = [
    'INFORMATIONS GÉNÉRALES',
    'GARANTIES',
    ...(contract?.exemption_link ? ['DÉROGATION & MESSAGES'] : []),
    ...(contract?.status !== 'QUOTE'
      ? ['DOCUMENTS', 'COMPTABILITÉ', 'SINISTRES', 'GED']
      : ''),
    'HISTORIQUE',
    ...(contract?.type !== 'PREVOYANCE' ? ['PRÉ-REQUIS'] : []),
    'MESSAGES'
  ];

  const switchTerminationRootContract = () => {
    setUpdateStatusVisible(false);
    setSwitchTerminationContract(true);
    setUpdateStatusVisible(true);
  };

  useEffect(() => {
    const handleScroll = () => {
      const position = document.getElementById('mainContent').scrollTop;
      let titleActive;
      for (let i = 0; i < title.length; i += 1) {
        if (
          (document.getElementById(title[i]) || {}).offsetTop <=
            position + 300 &&
          (document.getElementById(title[i]) || {}).offsetTop <=
            position + document.getElementById(title[i]).offsetHeight
        ) {
          titleActive = title[i];
        }
      }
      setActiveTitle(titleActive);
    };
    document
      .getElementById('mainContent')
      .addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      document
        .getElementById('mainContent')
        .removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line
  }, [isLoading]);
  const getSchema = async (type) => {
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/schemas/contract/${type}`
      });
      setSchema(data);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  const getContract = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/contracts/${id}?populate=exemption_link.assignee file ticket_messages.author, exemption.assignee file ticket_messages.author,insurer,quittances.paperwork_fee_invoice,amendment.insurer previous_contract,documents.files savedBy controledBy history.files user, history_documents.savedBy files, paperwork_fee_invoice`
      });
      setContract(data);
      await getSchema(data.type);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    setIsLoading(false);
    // eslint-disable-next-line
  }, [id, forceRefresh]);

  useEffect(() => {
    (async () => {
      await getContract();
    })();
    return () => {
      setContract({
        status: 'QUOTE'
      });
    };
  }, [getContract]);

  const displayActiveAmendment = () => {
    const revertAmendment = [...contract?.amendment];
    if (contract) {
      const amendment = revertAmendment
        .reverse()
        .find((element) => element.status === 'ACTIVE');
      if (amendment) {
        const [, amendmentNumber] = amendment.number
          .replace('DEV', '')
          .replace('PREV', '')
          .split('V');
        navigate({
          pathname: location.pathname,
          search: `?av=${Number(amendmentNumber) - 1}`
        });
      }
    }
  };

  useEffect(() => {
    if (contract?.amendment && contract?.amendment.length) {
      displayActiveAmendment();
    }
    // eslint-disable-next-line
  }, [contract]);

  useEffect(() => {
    setPaymentAlert(true);
    if (action === 'print_sign') {
      (() => {
        setOpenLastStepModal(true);
      })();
    }
    if (action === 'quittance_payment') {
      (() => {
        setPaymentModal(true);
      })();
    }
    // eslint-disable-next-line
  }, [action]);

  useEffect(() => {
    if (paperworkFeeNotPaid) {
      (() => {
        setPaymentModal(true);
      })();
    }
    // eslint-disable-next-line
  }, [paperworkFeeNotPaid, contract?.payment_type]);

  const handleTabChange = (key) => {
    navigate({
      pathname: location.pathname,
      search: `?av=${key}`
    });
  };

  // TODO: FIX SCROLL BUG ON HEADER PANEL CLICK
  const titleChange = (item) => {
    document.getElementById(item).scrollIntoView({ behavior: 'smooth' });
    setOpenPanel(true);
  };

  const pinLocation = {
    address:
      contract?.buildings && contract?.buildings[0]?.address?.formatted_address,
    lat: contract?.buildings && contract?.buildings[0]?.address?.lat,
    lng: contract?.buildings && contract?.buildings[0]?.address?.lng
  };

  const updateTicket = async (ticketId, messageText) => {
    try {
      await dispatchAPI('POST', {
        url: `/tickets/message/${ticketId}`,
        body: { messageText }
      });
      await getContract();
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  const downloadFile = async (file) => {
    setSpinLoading(true);
    if (file === null) return;
    try {
      const response = await dispatchAPI('GET', {
        url: `/contracts/files/${contract?._id}/${file._id}`,
        responseType: 'blob'
      });
      const blob = new Blob([response.data], {
        type: response.data.type
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${file.metadata.originalName}`;
      a.click();
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    setSpinLoading(false);
  };

  return (
    <>
      <ExemptionModal
        openExemptionModal={openExemptionModal}
        setOpenExemptionModal={setOpenExemptionModal}
        tempData={tempData}
        getContract={getContract}
      />
      <UpdateDetailsDrawer
        customer={
          contract?.customer && activeTab !== 'root'
            ? contract?.amendment[activeTab]?.customer
            : contract?.customer
        }
        id={
          contract?._id && activeTab !== 'root'
            ? contract?.amendment[activeTab]?._id
            : contract?._id
        }
        type={contract?.type}
      />
      <Affix offsetTop={71}>
        <Spin spinning={isLoading}>
          <div>
            <Tabs
              activeKey={activeTitle}
              centered
              onTabClick={(key) => titleChange(key)}
            >
              {contract &&
              ['UNPAID_1', 'UNPAID_2', 'UNPAID_3'].includes(contract.status)
                ? title.map((item) => (
                    // eslint-disable-next-line react/jsx-indent
                    <TabPane
                      tab={
                        <span
                          style={{
                            color: item === 'COMPTABILITÉ' ? 'red' : ''
                          }}
                        >
                          {item}
                        </span>
                      }
                      key={item}
                    />
                  ))
                : title.map((item) => <TabPane tab={item} key={item} />)}
            </Tabs>
          </div>
        </Spin>
        <InfosBar
          contractType={contract?.type?.toLowerCase()}
          showRestrictionButton={false}
        />
      </Affix>
      <PageHeader
        title={!isLoading ? pageHeaderTitle : ''}
        extra={
          <Actions
            isLoading={isLoading}
            contract={contract}
            openLastStepModal={openLastStepModal}
            setOpenLastStepModal={setOpenLastStepModal}
            shownContract={shownContract}
          />
        }
      />
      {contract?.exemption?.status === 'ACCEPTED' ? (
        <ContentCustom>
          <Typography.Text level={4} type="danger">
            {contract?.type?.toLowerCase() !== 'rcngawk'
              ? t('contracts.show.exemption_accepted')
              : t('contracts.show.exemption_accepted_rcngawk')}
          </Typography.Text>
        </ContentCustom>
      ) : (
        ''
      )}
      {contract?.exemption_link && !isCustomer && (
        <div id={title[3]}>
          <ContentCustom>
            <Typography.Title level={4}>
              {t('tickets.title_exemption')}
            </Typography.Title>
            <Skeleton loading={isLoading}>
              {contract?.exemption && (
                <DescriptionList schema={schema} data={list || []} />
              )}
              <Messages
                ticket={contract?.exemption_link}
                updateTicket={updateTicket}
              />
            </Skeleton>
          </ContentCustom>
        </div>
      )}
      <ContentCustom style={{ background: 'var(--bodyBackground)' }}>
        <div id={title[0]}>
          <Collapse ghost activeKey={1}>
            <Panel
              header={
                <>
                  {contract?.termination_date &&
                    contract?.termination_reason !== 'AMENDMENT' &&
                    moment(contract?.termination_date).isAfter(moment()) && (
                      <Typography
                        style={{
                          color: 'red',
                          textAlign: 'center',
                          marginBottom: 14
                        }}
                      >
                        {`${t('contracts.show.termination')} ${moment(
                          contract?.termination_date
                        ).format('DD/MM/YYYY')}`}
                      </Typography>
                    )}
                  {contract?.status === 'QUOTE' &&
                    contract?.previous_contract && (
                      <Typography
                        style={{
                          color: 'red',
                          textAlign: 'center',
                          marginBottom: 14
                        }}
                      >
                        {t('contracts.show.amendment_quote_info')}
                      </Typography>
                    )}
                  {contract.status === 'ACTIVE' && paperworkFeeNotPaid && (
                    <Typography
                      style={{
                        color: 'red',
                        textAlign: 'center',
                        marginBottom: 14
                      }}
                    >
                      {t('contracts.show.paperwork_fee_not_paid')}
                    </Typography>
                  )}
                  {!statusMissingParts.includes(contract?.status) &&
                    moment().isAfter(
                      moment(contract?.effective_date).add(10, 'days')
                    ) &&
                    contract?.documents?.find(
                      (f) => f.status === 'MISSING'
                    ) && (
                      <Typography
                        style={{
                          color: 'red',
                          textAlign: 'center',
                          flexDirection: 'row',
                          marginBottom: 14
                        }}
                      >
                        {t('contracts.show.missing_parts')}
                      </Typography>
                    )}
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {contract?.documents?.filter((f) => f.status === 'MISSING')
                      .length !== 0 &&
                      !statusMissingParts.includes(contract?.status) && (
                        <Button
                          type="danger"
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            marginBottom: 16
                          }}
                          onClick={() =>
                            navigate(
                              `${customerRoutes.MISSING_PARTS}/show/${contract?._id}`
                            )
                          }
                        >
                          {t('buttons.missign_parts_link')}
                        </Button>
                      )}
                    {paperworkFeeDrawn && (
                      <Button
                        type="danger"
                        style={{
                          display: 'flex',
                          marginBottom: 16,
                          marginLeft: '22px'
                        }}
                      >
                        {t('buttons.missign_FD_payment')}
                      </Button>
                    )}
                  </div>
                  {contract?.status !== 'QUOTE' ? (
                    <div style={{ textAlign: 'center' }}>
                      <Tag
                        color={contractsStatuses[contract?.status]}
                        style={{ fontSize: 25, fontWeight: 'bold' }}
                      >
                        {t(`contracts.tags.${contract?.status}`)}
                      </Tag>
                    </div>
                  ) : (
                    ''
                  )}
                  <Typography.Title level={4}>
                    {t('contracts.show.general_info')}
                  </Typography.Title>
                </>
              }
              key={1}
            >
              {contract?.status !== 'QUOTE' &&
                contract?.amendment &&
                contract?.amendment.length > 0 && (
                  <Tabs
                    type="card"
                    onChange={handleTabChange}
                    activeKey={activeTab}
                  >
                    {[contract, ...contract?.amendment].map((a, index) => (
                      <TabPane
                        key={index === 0 ? 'root' : index - 1}
                        tab={
                          <p
                            style={{
                              textDecoration:
                                a.status === 'WITHOUT_EFFECT'
                                  ? 'line-through'
                                  : ''
                            }}
                          >
                            {index === 0 ? 'CONTRAT' : `AVENANT ${index}`}
                          </p>
                        }
                      />
                    ))}
                  </Tabs>
                )}
              <Skeleton loading={isLoading}>
                <DescriptionList
                  schema={schema}
                  values={shownContract}
                  activeTab={activeTab}
                  data={costInfo || []}
                  exemptions={contract?.exemption?.exemptions}
                  type={contract?.type?.toLowerCase()}
                  getContract={getContract}
                  setVisibleModal={setOpenExemptionModal}
                  setTempData={setTempData}
                />
              </Skeleton>
              {contract?.status !== 'QUOTE' && (
                <>
                  <Typography.Paragraph level={5}>
                    {t('contracts.form.contract_status_info.title')}
                  </Typography.Paragraph>
                  <UpdateContractStatusInfo
                    contract={
                      (amendmentIndex && amendmentIndex === 'root') ||
                      switchTerminationContract ||
                      !contract.amendment.length
                        ? contract
                        : contract?.amendment[amendmentIndex]
                    }
                    id={id}
                    getContract={getContract}
                    switchTerminationRootContract={
                      switchTerminationRootContract
                    }
                  />
                  <Skeleton loading={isLoading}>
                    <DescriptionList
                      schema={schema}
                      exemptions={contract?.exemption?.exemptions}
                      activeTab={activeTab}
                      data={contractStatusInfo || []}
                      type={contract?.type?.toLowerCase()}
                      getContract={getContract}
                      setVisibleModal={setOpenExemptionModal}
                      setTempData={setTempData}
                    />
                  </Skeleton>
                </>
              )}
              {!!antecedentsInfo && (
                <>
                  <Typography.Paragraph level={4}>
                    {t('contracts.form.antecedents')}
                  </Typography.Paragraph>
                  <Skeleton loading={isLoading}>
                    <DescriptionList
                      schema={schema}
                      exemptions={contract?.exemption?.exemptions}
                      values={shownContract}
                      activeTab={activeTab}
                      data={antecedentsInfo || []}
                      type={contract?.type?.toLowerCase()}
                      getContract={getContract}
                      setVisibleModal={setOpenExemptionModal}
                      setTempData={setTempData}
                    />
                  </Skeleton>
                </>
              )}
              {contract?.status !== 'QUOTE' && (
                <>
                  <Typography.Paragraph level={4}>
                    {t('contracts.form.adjustment_contribution')}
                  </Typography.Paragraph>
                  <Skeleton loading={isLoading}>
                    <DescriptionList
                      schema={schema}
                      exemptions={contract?.exemption?.exemptions}
                      values={shownContract}
                      activeTab={activeTab}
                      data={contributionInfo || []}
                      type={contract?.type?.toLowerCase()}
                      getContract={getContract}
                    />
                  </Skeleton>
                </>
              )}
            </Panel>
          </Collapse>
        </div>
      </ContentCustom>
      <ContentCustom
        marginTop={8}
        style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
      >
        <div id={title[1]}>
          <Collapse ghost id={title[1]} defaultActiveKey={2}>
            <Panel
              header={
                <Typography.Title level={4}>
                  {t('quotes.show.contractInfo.guarantee')}
                </Typography.Title>
              }
              key={2}
            >
              <Skeleton loading={isLoading}>
                {contract?.type === 'MRI' && pinLocation.lat && (
                  <GoogleMap pinLocation={pinLocation} zoomLevel={17} />
                )}
                <DescriptionList
                  schema={schema}
                  exemptions={contract?.exemption?.exemptions}
                  values={shownContract}
                  activeTab={activeTab}
                  data={contractInfo || []}
                  type={contract?.type?.toLowerCase()}
                  getContract={getContract}
                  setVisibleModal={setOpenExemptionModal}
                  setTempData={setTempData}
                />
              </Skeleton>
              {contract?.type !== 'PREVOYANCE' && (
                <>
                  <Typography.Paragraph level={4}>
                    {t('articles.form.options')}
                  </Typography.Paragraph>
                  <Skeleton loading={isLoading}>
                    <DescriptionList
                      schema={schema}
                      exemptions={contract?.exemption?.exemptions}
                      values={shownContract}
                      activeTab={activeTab}
                      data={optionInfo || []}
                      type={contract?.type?.toLowerCase()}
                      getContract={getContract}
                      setVisibleModal={setOpenExemptionModal}
                      setTempData={setTempData}
                    />
                  </Skeleton>
                </>
              )}
              {contract?.status === 'QUOTE' &&
                (contract?.exemption?.status === 'ACCEPTED' ||
                  !contract?.exemption?.status) && (
                  <div id={title[2]}>
                    <Typography.Paragraph level={4}>
                      {t('contracts.form.adjustment_contribution')}
                    </Typography.Paragraph>
                    <Skeleton loading={isLoading}>
                      <DescriptionList
                        schema={schema}
                        exemptions={contract?.exemption?.exemptions}
                        values={shownContract}
                        activeTab={activeTab}
                        data={contributionInfo || []}
                        type={contract?.type?.toLowerCase()}
                        getContract={getContract}
                        setVisibleModal={setOpenExemptionModal}
                        setTempData={setTempData}
                      />
                    </Skeleton>
                  </div>
                )}
            </Panel>
          </Collapse>
        </div>
      </ContentCustom>
      {contract?.status !== 'QUOTE' && (
        <>
          <ContentCustom
            marginTop={8}
            style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
          >
            <div id={title[2]}>
              <Collapse ghost>
                <Panel
                  header={
                    <Typography.Title level={4}>
                      {t('documents.title')}
                    </Typography.Title>
                  }
                  key={3}
                >
                  <MyDocuments
                    contract={contract}
                    downloadFile={downloadFile}
                    spinLoading={spinLoading}
                  />
                </Panel>
              </Collapse>
            </div>
          </ContentCustom>
          <ContentCustom
            marginTop={8}
            style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
          >
            <div id={title[3]}>
              <Collapse ghost defaultActiveKey={4}>
                <Panel
                  header={
                    <Typography.Title level={4}>
                      {t('contracts.form.accounting')}
                    </Typography.Title>
                  }
                  key={4}
                >
                  <Typography.Paragraph level={4}>
                    {t('validate_quote.form.banking_information')}
                  </Typography.Paragraph>
                  {!isCustomer && (
                    <UpdateBankInfo
                      contract={contract}
                      shownContract={shownContract}
                      style={{ float: 'right' }}
                    />
                  )}
                  <Skeleton loading={isLoading}>
                    <DescriptionList
                      schema={schema}
                      exemptions={contract?.exemption?.exemptions}
                      values={
                        activeTab === 'root' || !contract?.amendment
                          ? contract
                          : contract?.amendment[activeTab]
                      }
                      activeTab={activeTab}
                      data={bankInfo || []}
                    />
                  </Skeleton>
                  <Typography.Paragraph level={4}>
                    {t('quittances.form.title')}
                  </Typography.Paragraph>
                  <QuittanceTable
                    data={contract?.quittances.sort(
                      (a, b) =>
                        new Date(a.period_date) - new Date(b.period_date)
                    )}
                    contractStatus={contract?.status}
                  />
                  {!!contract?.paperwork_fee_invoice.length && (
                    <>
                      <Typography.Paragraph level={4}>
                        {t('paperWorkFee.form.title')}
                      </Typography.Paragraph>
                      {contract?.paperwork_fee_invoice[0]
                        ?.paperwork_fee_payment_choices === 'FREE' && (
                        <p>{t('paperWorkFee.form.subtitle')}</p>
                      )}
                      <PaperWorkFeeTable
                        data={contract.paperwork_fee_invoice}
                        contractStatus={contract.status}
                      />
                    </>
                  )}
                  {(!!contract?.paperwork_fee_invoice.length ||
                    contract.payment_type === 'CARD') && (
                    <PaperworkFeePaymentModal
                      paymentModal={paymentModal}
                      setIsLoading={setIsLoading}
                      isLoading={isLoading}
                      paperworkFee={contract?.paperwork_fee_invoice.filter(
                        (p) => p.paperworkFee_status === 'NOT_PAID'
                      )}
                      setPaymentModal={setPaymentModal}
                      contract={contract}
                    />
                  )}
                  {contract &&
                  ['UNPAID_1', 'UNPAID_2', 'UNPAID_3'].includes(
                    contract.status
                  ) ? (
                    <PaymentAlertModal
                      paymentAlert={paymentAlert}
                      setPaymentAlert={setPaymentAlert}
                    />
                  ) : (
                    <></>
                  )}
                </Panel>
              </Collapse>
            </div>
          </ContentCustom>
          <ContentCustom
            marginTop={8}
            style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
          >
            <div id={title[4]}>
              <Collapse ghost className="show-contract-collapse">
                <Panel
                  header={
                    <Typography.Title level={4}>
                      {t('contracts.form.termination_claims')}
                    </Typography.Title>
                  }
                  key={5}
                />
              </Collapse>
            </div>
          </ContentCustom>
          <ContentCustom
            marginTop={8}
            style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
          >
            <div id={title[5]}>
              <Collapse
                ghost
                className="show-contract-collapse"
                activeKey={openPanel ? 6 : [undefined]}
                onChange={() => setOpenPanel(!openPanel)}
              >
                <Panel
                  header={
                    <Typography.Title level={4}>
                      {t('contracts.form.ged')}
                    </Typography.Title>
                  }
                  key={6}
                >
                  <MissingDocuments
                    contract={contract}
                    downloadFile={downloadFile}
                    spinLoading={spinLoading}
                  />
                </Panel>
              </Collapse>
            </div>
          </ContentCustom>
        </>
      )}
      <ContentCustom
        marginTop={8}
        style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
      >
        <div id={contract?.status !== 'QUOTE' ? title[6] : title[3]}>
          <Collapse ghost className="show-contract-collapse">
            <Panel
              header={
                <Typography.Title level={4}>
                  {t('contracts.form.historic')}
                </Typography.Title>
              }
              key={7}
            >
              <Historic data={contract?.historic} />
            </Panel>
          </Collapse>
        </div>
      </ContentCustom>
      {contract?.type !== 'PREVOYANCE' && (
        <ContentCustom
          marginTop={8}
          style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
        >
          <div id={contract?.status === 'QUOTE' ? title[5] : title[7]}>
            <Collapse
              ghost
              defaultActiveKey={7}
              className="show-contract-collapse"
            >
              <Panel
                header={
                  <Typography.Title level={4}>
                    {t('quotes.form.rcp.secondStep')}
                  </Typography.Title>
                }
                key={7}
              >
                <Skeleton loading={isLoading}>
                  <DescriptionList
                    schema={schema}
                    exemptions={contract?.exemption?.exemptions}
                    values={shownContract}
                    activeTab={activeTab}
                    data={firstStepInfo || []}
                    type={contract?.type?.toLowerCase()}
                    getContract={getContract}
                    setVisibleModal={setOpenExemptionModal}
                    setTempData={setTempData}
                  />
                </Skeleton>
              </Panel>
            </Collapse>
          </div>
        </ContentCustom>
      )}
      <ContentCustom
        marginTop={8}
        style={{ background: 'var(--bodyBackground)', paddingTop: 0 }}
      >
        <div id="MESSAGES">
          <Collapse ghost className="show-contract-collapse">
            <Panel
              header={
                <Typography.Title level={4}>
                  {t('messages.title1')}
                </Typography.Title>
              }
              key={7}
            >
              <Skeleton loading={isLoading}>
                <MessageHistory
                  id={contract?._id}
                  downloadFile={downloadFile}
                />
              </Skeleton>
            </Panel>
          </Collapse>
        </div>
      </ContentCustom>
    </>
  );
};

export default ShowContract;
